var _rect, _rect2, _rect3, _g, _polygon, _g2, _polygon2, _g3, _polygon3, _polygon4, _polygon5, _polygon6, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSiKolor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "113.39px",
    height: "127.56px",
    viewBox: "0 0 113.39 127.56",
    enableBackground: "new 0 0 113.39 127.56",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.263,
    y: 8.023,
    fill: "#E1001A",
    width: 45,
    height: 45
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.263,
    y: 58.023,
    fill: "#E1001A",
    width: 45,
    height: 45
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 61.263,
    y: 58.023,
    fill: "#E1001A",
    width: 45,
    height: 45
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -195.667,
    y: -234.276,
    width: 841.89,
    height: 595.276
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#6F7072",
    d: "M66.168,37.515c1.681,1.833,4.371,3.561,7.515,3.561 c1.832,0,3.012-0.576,3.678-1.205c0.597-0.523,1.074-1.309,1.199-2.199c0.094-0.681-0.058-1.466-0.701-2.095 c-0.78-0.785-2.09-1.152-4.246-1.832l-2.254-0.734c-1.401-0.471-3.438-1.256-4.631-2.828c-1.51-1.938-1.373-4.399-1.121-6.18 c0.603-4.294,2.646-6.913,4.379-8.431c2.033-1.782,5.178-3.3,9.42-3.3c3.457,0,7.334,1.1,10.393,2.828l-4.607,7.07 c-2.422-2.147-4.436-2.356-5.641-2.356c-0.891,0-2.124,0.209-3.133,1.047c-0.598,0.524-1.045,1.1-1.154,1.885 c-0.089,0.629-0.05,1.1,0.25,1.572c0.219,0.314,0.758,0.942,2.817,1.57l2.657,0.839c2.104,0.68,4.299,1.466,5.852,3.456 c1.516,1.885,1.717,3.823,1.377,6.232c-0.449,3.195-1.669,6.285-4.537,8.799c-3.404,2.985-7.099,3.561-10.818,3.561 c-2.198,0-4.264-0.21-6.698-1.153c-0.546-0.209-2.628-1.047-4.899-2.775L66.168,37.515z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#6F7072",
    points: "106.263,13.057 101.353,47.988 92.294,47.988 97.202,13.057 "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -195.667,
    y: -234.276,
    width: 841.89,
    height: 595.276
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#6F7072",
    d: "M18.441,118.196c-1.111,0.383-1.711,0.506-2.369,0.506 c-1.778,0-3.01-0.705-3.737-1.532c-0.856-0.997-1.211-2.391-1.024-3.723c0.204-1.456,1.026-2.835,2.077-3.771 c1.033-0.919,2.491-1.593,4.084-1.593c0.49,0,1.276,0.077,2.317,0.521l-0.446,3.171c-0.71-1.058-1.712-1.118-2.157-1.118 c-0.766,0-1.38,0.229-1.932,0.674c-0.71,0.582-1.083,1.379-1.184,2.099c-0.099,0.705,0.083,1.486,0.548,1.992 c0.386,0.414,1.05,0.705,1.8,0.705c0.398,0,1.385-0.046,2.464-1.073L18.441,118.196z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#6F7072",
    d: "M24.187,111.409c-0.627,0.535-0.993,1.286-1.093,2.007 c-0.127,0.903,0.212,1.532,0.544,1.899c0.423,0.476,1.065,0.813,1.953,0.813c0.904,0,1.624-0.322,2.165-0.796 c0.542-0.477,0.992-1.182,1.103-1.962c0.111-0.796-0.142-1.501-0.552-1.961c-0.492-0.536-1.234-0.813-1.938-0.813 C25.634,110.597,24.816,110.856,24.187,111.409 M29.472,117.185c-1.182,0.996-2.726,1.518-4.243,1.518 c-1.516,0-2.913-0.521-3.815-1.518c-0.94-1.042-1.261-2.467-1.071-3.814c0.191-1.363,0.914-2.805,2.145-3.83 c1.183-0.996,2.727-1.518,4.243-1.518c1.516,0,2.914,0.521,3.815,1.518c0.943,1.025,1.262,2.467,1.07,3.83 C31.426,114.718,30.705,116.143,29.472,117.185"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#6F7072",
    points: "32.581,118.473 34.017,108.252 36.668,108.252 40.675,114.504 41.554,108.252 44.205,108.252  42.768,118.473 40.118,118.473 36.109,112.22 35.231,118.473 "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: -195.667,
    y: -234.276,
    width: 841.89,
    height: 595.276
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_6_)",
    fill: "#6F7072",
    d: "M46.015,115.408c0.491,0.536,1.278,1.041,2.197,1.041 c0.535,0,0.881-0.168,1.075-0.353c0.175-0.152,0.315-0.383,0.352-0.643c0.028-0.2-0.017-0.429-0.205-0.613 c-0.229-0.229-0.612-0.337-1.243-0.537l-0.659-0.214c-0.409-0.138-1.005-0.368-1.354-0.827c-0.441-0.566-0.401-1.288-0.328-1.809 c0.177-1.256,0.775-2.022,1.281-2.467c0.595-0.521,1.515-0.964,2.755-0.964c1.011,0,2.146,0.32,3.039,0.826l-1.348,2.068 c-0.707-0.628-1.297-0.688-1.648-0.688c-0.261,0-0.622,0.061-0.917,0.306c-0.174,0.153-0.306,0.322-0.338,0.552 c-0.026,0.185-0.014,0.322,0.073,0.46c0.063,0.091,0.223,0.275,0.824,0.46l0.778,0.245c0.615,0.198,1.256,0.428,1.711,1.011 c0.443,0.552,0.501,1.118,0.402,1.823c-0.131,0.936-0.488,1.838-1.326,2.574c-0.996,0.873-2.077,1.042-3.165,1.042 c-0.643,0-1.247-0.063-1.959-0.337c-0.159-0.062-0.768-0.307-1.432-0.813L46.015,115.408z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_6_)",
    fill: "#6F7072",
    d: "M57.741,108.252l-0.851,6.053c-0.06,0.429-0.137,1.088,0.299,1.577 c0.265,0.291,0.728,0.49,1.188,0.49c0.459,0,0.961-0.183,1.287-0.443c0.689-0.536,0.778-1.287,0.857-1.854l0.819-5.823h2.65 l-0.825,5.868c-0.151,1.073-0.354,2.191-1.614,3.311c-0.98,0.874-2.108,1.271-3.548,1.271c-1.61,0-2.681-0.552-3.213-1.226 c-0.754-0.965-0.678-2.269-0.525-3.356l0.825-5.868H57.741z"
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#6F7072",
    points: "68.782,108.252 67.662,116.221 70.849,116.221 70.531,118.473 64.695,118.473 66.132,108.252 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#6F7072",
    points: "75.925,110.504 74.804,118.473 72.154,118.473 73.274,110.504 71.099,110.504 71.417,108.252  78.417,108.252 78.099,110.504 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#6F7072",
    points: "82.243,108.252 80.806,118.473 78.156,118.473 79.593,108.252 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#6F7072",
    points: "82.95,118.473 84.388,108.252 87.037,108.252 91.045,114.504 91.924,108.252 94.573,108.252  93.138,118.473 90.487,118.473 86.479,112.22 85.601,118.473 "
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: -195.667,
    y: -234.276,
    width: 841.89,
    height: 595.276
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_8_)",
    fill: "#6F7072",
    d: "M100.993,112.681h5.27c-0.285,2.021-0.9,3.463-2.285,4.596 c-1.213,0.996-2.479,1.287-3.78,1.287c-1.838,0-3-0.674-3.708-1.517c-0.658-0.766-1.189-2.008-0.951-3.692 c0.229-1.624,1.059-2.957,2.07-3.83c0.96-0.843,2.37-1.502,4.178-1.502c0.95,0,1.946,0.214,2.66,0.69 c0.729,0.489,1.273,1.302,1.528,2.099l-2.675,1.042c-0.116-0.475-0.36-0.813-0.59-1.027c-0.394-0.367-0.849-0.506-1.354-0.506 c-0.628,0-1.305,0.23-1.846,0.705c-0.682,0.598-1.105,1.548-1.217,2.344c-0.131,0.936,0.098,1.701,0.5,2.207 c0.416,0.521,0.978,0.781,1.76,0.781c0.457,0,1.007-0.076,1.537-0.475c0.272-0.199,0.615-0.567,0.787-1.135h-2.176L100.993,112.681 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSiKolor);
export default __webpack_public_path__ + "static/media/logo_si_kolor.46d4e240ffd5efbc4cf8d432477811fd.svg";
export { ForwardRef as ReactComponent };